var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c("div", { staticClass: "page-content g9" }, [
        _c("h2", [_vm._v("Users")]),
        _vm._v(" "),
        _c("div", { staticClass: "accord", class: { closed: _vm.isClosed } }, [
          _c("header", { on: { click: _vm.onToggle } }, [
            _vm._v("Users"),
            _c("span", { attrs: { title: "open / close" } }),
          ]),
          _vm._v(" "),
          !_vm.isClosed
            ? _c(
                "article",
                [
                  _vm._t("default", function () {
                    return [
                      _c("div", { staticClass: "grid-100w" }, [
                        _c("table", { staticClass: "list" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.members, function (member) {
                              return _c("tr", [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/member/edit/" + member.memberId,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(member.firstName) +
                                            " " +
                                            _vm._s(member.lastName) +
                                            "\n                                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(member.createDateString)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      member.lastSuccessfulValidationUtcString
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(member.email))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(member.memberRoleName)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  member.isLocked
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                                            yes\n                                        "
                                        ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          "\n                                            no\n                                        "
                                        ),
                                      ]),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Created")]),
        _vm._v(" "),
        _c("th", [_vm._v("LastLogin")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Role")]),
        _vm._v(" "),
        _c("th", [_vm._v("Locked")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }